import { SurveyViewContext } from './SurveyViewContext';
import { SurveyViewControllerProps } from './SurveyViewController.types';

export const SurveyViewController = ({ isEditInputOnly, children }: SurveyViewControllerProps) => {
  return <SurveyViewContext.Provider value={{ isEditInputOnly }}>{children}</SurveyViewContext.Provider>;
};
